import { WORKOUT_SECTION_KEY, WORKOUT_SECTION_TYPE } from '../../../model'
import updateWorkoutSectionAction from '../update'
import WORKOUT_SECTIONS_ACTION from '../../constants/action'
import WORKOUT_SECTIONS_ANALYTICS_EVENT from '../../constants/analytics-event'
import { logEventAnalyticsUtil } from '../../../../../utils/analytics/log-event'

function convertToStandardWorkoutSectionAction (id) {
  return (dispatch) => {
    dispatch(updateWorkoutSectionAction({
      type: WORKOUT_SECTIONS_ACTION.CONVERT_TO_STANDARD,
      payload: {
        key: WORKOUT_SECTION_KEY.TYPE,
        value: WORKOUT_SECTION_TYPE.STRENGTH,
        id
      }
    }))
    logEventAnalyticsUtil(WORKOUT_SECTIONS_ANALYTICS_EVENT.CONVERTED_TO_STANDARD_SECTION,
      {
        id
      }
    )
  }
}

export default convertToStandardWorkoutSectionAction
